import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ACCESS_KEY = "dk_access";
const REFRESH_KEY = "dk_refresh";

export const getAccess = () => localStorage.getItem(ACCESS_KEY) || "";
export const getRefresh = () => localStorage.getItem(REFRESH_KEY) || "";
export const setTokens = (access, refresh) => {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
};
export const clearTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getAccess();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error?.response?.status === 401 && !original._retry && getRefresh()) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios.post(`${API_BASE}/auth/refresh`, { refresh_token: getRefresh() });
        }
        const res = await refreshing;
        refreshing = null;
        setTokens(res.data.access_token, res.data.refresh_token);
        original.headers.Authorization = `Bearer ${res.data.access_token}`;
        return api.request(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
      }
    }
    return Promise.reject(error);
  }
);
